import React, { useContext } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import ElementRenderer from "../components/tree/ElementRenderer";
import { CustomizerContext } from "../context/CustomizerContext";
import { GENERAL_DEFINITION } from "../helpers/DataDefinitions";
import { useYObject } from "../hooks/documentHooks";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px;
  empty-data {
    margin: 16px;
  }
`

const DataSettingsTreeView = ({ dataToShow }) => {
  const { document } = useContext(CustomizerContext);
  const dataMap = document && document.getMap(dataToShow);
  const data = useYObject(dataMap);
  const dataLength = Object.keys(data || {}).length;
  const currentData = useSelector(state => state.selectedLanguageData)
  const dataTranslationMap = document && currentData && document.getMap(currentData)
  const dataTranslation = useYObject(dataTranslationMap)

  return (
    <Container>
      {dataMap && (
        <ElementRenderer
          definition={GENERAL_DEFINITION}
          value={dataMap}
          dataTranslation={dataTranslation}
          dataTranslationMap={dataTranslationMap}
        />
      )}
    </Container>
  )
}

export default DataSettingsTreeView
